import React from "react";
import SbEditable from "storyblok-react";
import FluidImage from "src/utils/FluidImage";

const TwoColumnsImages = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="bg-white">
        <div className="relative max-w-7xl mx-auto my-16 px-4 sm:px-6 lg:px-8">
          <div className="mx-auto text-base max-w-prose lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-none">
            <div>
              <FluidImage
                className="object-cover object-center"
                image={blok.image_one}
              />
              <p
                className={`text-sm mt-2 italic ${
                  blok.content_type === "magazine"
                    ? "font-insights-body font-bold"
                    : "font-body"
                }`}
              >
                {blok.image_one_label}
              </p>
            </div>
            <div>
              <FluidImage
                className="object-cover object-center"
                image={blok.image_two}
              />
              <p
                className={`text-sm mt-2 italic ${
                  blok.content_type === "magazine"
                    ? "font-insights-body font-bold"
                    : "font-body"
                }`}
              >
                {blok.image_two_label}
              </p>
            </div>
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default TwoColumnsImages;
